<style lang="scss" scoped>
.slide-12 {
  background-image: url(../../../assets/module2/slide12/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 100px;
  padding-left: 90px;

  h1 {
    font-size: 50px;
  }

  .heading1 {
    color: #c5d43b;
    margin-left: 0px;
  }
  .heading2 {
    color: #c5d43b;
    margin-left: 30px;
  }
  .heading3 {
    color: #c5d43b;
    margin-left: 50px;
  }
  .heading4 {
    color: #c5d43b;
    margin-left: 0px;
  }
  .heading5 {
    color: #fff;
    transform: rotate(-5deg);
    font-size: 90px;
  }

  .white {
    color: #fff;
  }

  .red {
    color: #c90c0f;
  }

  .number-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;
  }

  .number {
    font-size: 150px;
    line-height: 150px;
  }

  .copy1 {
    margin-left: 30px;
    width: 45%;
    color: #fff;
  }
}
</style>

<template>
  <div class="slide-12">
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 11"
        src="@/assets/module2/slide12/photo-01.png"
        class="chars delay-3"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 11"
        src="@/assets/module2/slide12/timmy-01.png"
        class="chars delay-2"
      />
    </transition>
    <div class="heading">
      <transition name="fadeUp" appear>
        <h1
          class="heading1 delay-1"
          v-html="$t('module2.slide12.heading1')"
          v-show="slideIndex == 11"
        ></h1>
      </transition>
      <transition name="fadeUp" appear>
        <h1
          class="heading2 delay-2"
          v-html="$t('module2.slide12.heading2')"
          v-show="slideIndex == 11"
        ></h1>
      </transition>
      <transition name="fadeUp" appear>
        <h1 class="heading3 delay-3" v-show="slideIndex == 11">
          <span class="white">{{ $t("module2.slide12.heading3") }}</span>
          {{ $t("module2.slide12.heading4") }}
        </h1>
      </transition>
      <transition name="fadeUp" appear>
        <h1 class="heading4 delay-4" v-show="slideIndex == 11">
          {{ $t("module2.slide12.heading5") }}
          <span class="white">{{ $t("module2.slide12.heading6") }}</span>
          {{ $t("module2.slide12.heading7") }}
        </h1>
      </transition>
    </div>

    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 11" class="number-wrapper delay-5">
        <h1 class="heading5">
          {{ $t("module2.slide12.heading8") }}
        </h1>
        <h1>
          <span class="red number">{{ $t("module2.slide12.heading9") }}</span>
        </h1>
      </div>
    </transition>

    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 11" class="delay-6">
        <p class="copy1">{{ $t("module2.slide12.copy1") }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
